var map = {
	"./atmire/app/header/header.component": [
		"tnwv"
	],
	"./client/app/header/header.component": [
		"Ys+4"
	],
	"./custom/app/header/header.component": [
		"tppE",
		97
	],
	"./dspace/app/header/header.component": [
		"acxG",
		159
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "M7g8";
module.exports = webpackAsyncContext;